import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Grid, Ref } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { getPropertyItemTitle } from "../../helpers/general-helpers";
import { CONFIRMATION_ANALYTICS_PHASE } from "../../constants/general";
import { resetStore } from "../../actions/resetStoreActions";
import {
  getPlaceHolders,
  clearAnalyticsPlaceHolders,
  getAnalyticsPlaceHolders
} from "../../actions/placeHoldersActions";
import { isRTL, getSelectedHotelName } from "../../reducers";
import { Header, IcoMoon, PlaceHolder } from "../../components/common";
import ErrorDialog from "../../components/ErrorDialog";
import styles from "./styles.less";
import cx from "classnames";

class Confirmation extends React.Component {
  state = {
    placeHoldersReceivedFromServer: false
  };

  componentDidMount = () => {
    setTimeout(this.props.onLoad, 0);
    // this.setState({
    //   reservationId: this.props.reservationId,
    //   registrationData: this.props.registrationData
    // });
    //const { actions } = this.props;
    //actions.resetStore();
  };

  componentDidUpdate = prevProps => {
    if (
      this.props.isFetchingConfirmationData !=
        prevProps.isFetchingConfirmationData &&
      prevProps.isFetchingConfirmationData
    ) {
      this.getConfirmationPlaceHolders();
      this.getAnalyticsPlaceHolders();
    }
  };

  componentWillUnmount() {
    const { actions } = this.props;
    actions.clearAnalyticsPlaceHolders();
  }

  /**
   * Get analytics code from server and append it to #page-analytics-wrapper element ( append action include the execution ).
   * Generate the code with the data stored until this phase
   */
  getAnalyticsPlaceHolders = () => {
    const {
      selectedHotelId,
      hotelName,
      checkinDate,
      checkoutDate,
      promoCode,
      orderSummary,
      orderCurrency,
      actions,
      reservationId,
      registrationData
    } = this.props;
    const rooms = orderSummary.map(r => ({
      RoomId: r.id,
      Price: r.price
    }));
    const postObject = {
      Phase: CONFIRMATION_ANALYTICS_PHASE,
      MasterId: reservationId,
      HotelId: selectedHotelId,
      Currency: orderCurrency && orderCurrency.currencyCode,
      HotelName: hotelName,
      CheckInDate: checkinDate,
      CheckoutDate: checkoutDate,
      RegistrationEmail: registrationData.Email,
      PromoCode: promoCode,
      Rooms: rooms
    };
    actions.getAnalyticsPlaceHolders(postObject);
  };

  getConfirmationPlaceHolders = () => {
    const {
      actions,
      orderSummary,
      reservationId,
      registrationData,
      orderCurrency
    } = this.props;
    const data =
      orderSummary &&
      orderSummary.map(elem => {
        return {
          RoomId: elem.id,
          RoomPrice: elem.price
        };
      });
    actions.getPlaceHolders({
      component: "ConfirmationPage",
      location: "Top",
      data,
      reservationId,
      userEmail: registrationData.Email,
      currency: orderCurrency.currencyCode
    });
    this.setState({ placeHoldersReceivedFromServer: true });
  };

  renderHeader = (title, isSubtitle) => {
    const { isRtl, isMobileView } = this.props;
    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <Header
            className={`${styles.confirmationHeader} ${styles.fontWeigher}`}
            noSidePadding={true}
            isRtl={isRtl}
            text={title}
            isMobileView={isMobileView}
            subtitle={isSubtitle}
          />
        </Grid.Column>
      </Grid.Row>
    );
  };

  handleConfirmationRef = node => {
    const { handleConfirmationRef } = this.props;
    if (handleConfirmationRef) {
      handleConfirmationRef(node);
    }
  };

  renderError = () => {
    const { titles, isRtl, isMobileView } = this.props;
    return (
      <ErrorDialog titles={titles} isRTL={isRtl} isMobileView={isMobileView} />
    );
  };

  showResults = () => {
    const { reservationId } = this.props;
    return reservationId ? this.renderConfirmation() : this.renderError();
  };

  renderRoomDetails = () => {
    const { titles, propertyType, orderSummary } = this.props;
    const numberOfRooms = orderSummary && orderSummary.length;
    const propertyItemTitle = getPropertyItemTitle(titles, propertyType);
    if (numberOfRooms > 1) {
      return orderSummary.map((elem, index) => {
        const roomNumber = ++index;
        return (
          <div className={styles.dataField} key={roomNumber + "PropertyItem"}>
            <span className={styles.title}>
              {propertyItemTitle + " " + roomNumber}:
            </span>
            {` ${elem && elem.name}`}
          </div>
        );
      });
    } else if (orderSummary) {
      return (
        <div className={styles.dataField}>
          <span className={styles.title}>
            {getPropertyItemTitle(titles, propertyType)}:
          </span>
          {` ${orderSummary[0] && orderSummary[0].name}`}
        </div>
      );
    }
  };

  renderConfirmation = () => {
    const {
      reservationId,
      registrationData,
      titles,
      checkinDate,
      checkoutDate,
      customText,
      CancellationPolicy,
      isMobileView,
      placeHolders
    } = this.props;

    return (
      <Grid
        className={cx(styles.confirmationWrapper, {
          [styles.mobileView]: isMobileView
        })}
        key={reservationId}
      >
        {
          <div className={styles.headerWrapper}>
            <IcoMoon name="check-mark" color="#01b401" size={30} />{" "}
            {this.renderHeader(titles.ReservationComplete)}
          </div>
        }
        {this.renderHeader(titles.ReservationCompleteSubtitle, true)}
        <PlaceHolder
          placeHolders={placeHolders}
          component={"ConfirmationPage"}
          location={"Top"}
        />
        <br />
        <br />
        <Grid.Row>
          <Grid.Column width={16}>
            <div className={`${styles.section} ${styles.details}`}>
              <div className={styles.dataField}>
                <span className={styles.title}>
                  {titles.ReservationNumber}:
                </span>
                {` ${reservationId}`}
              </div>
              {/* <div className={styles.dataField}>
                <span className={styles.title}>
                  {getPropertyTitle(titles, propertyType)}:
                </span>
                {` ${hotelName}`}
              </div> */}
              {this.renderRoomDetails()}
              <div className={styles.dataField}>
                <span className={styles.title}>{titles.CheckInDate}:</span>
                {` ${checkinDate}`}
              </div>
              <div className={styles.dataField}>
                <span className={styles.title}>{titles.CheckOutDate}:</span>
                {` ${checkoutDate}`}
              </div>
            </div>

            {titles.ConfirmationLoginInstruction &&
              registrationData.Email && (
                <div className={styles.section}>
                  {`* ${titles.ConfirmationLoginInstruction} (${
                    registrationData.Email
                  }).`}
                </div>
              )}

            {CancellationPolicy && (
              <div className={styles.section}>
                <div className={styles.dataField}>
                  <div className={styles.title}>
                    {titles.CancellationPolicy}:
                  </div>
                </div>
              </div>
            )}

            {customText && (
              <div className={`${styles.section} ${styles.customText}`}>
                {customText}
              </div>
            )}

            <div className={`${styles.section} ${styles.thankyou}`}>
              <div>{`${titles.ThankYou} , `}</div>
              <div>{titles.WeLookForward}</div>
            </div>

            <PlaceHolder
              placeHolders={placeHolders}
              component={"ConfirmationPage"}
              location={"Bottom"}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  renderLoader = () => {
    const { renderLoader, titles } = this.props;
    return <Grid center>{renderLoader(true, titles.ProccessingOrder)}</Grid>;
  };

  render() {
    const { isFetchingConfirmationData } = this.props;
    return (
      <Ref innerRef={this.handleConfirmationRef}>
        {isFetchingConfirmationData ? this.renderLoader() : this.showResults()}
      </Ref>
    );
  }
}

Confirmation.defaultProps = {
  customText: ""
};

Confirmation.propTypes = {
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  // lang: PropTypes.string,
  isRtl: PropTypes.bool,
  customText: PropTypes.string,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  reservationId: PropTypes.number,
  registrationData: PropTypes.object,
  isFetchingConfirmationData: PropTypes.bool,
  renderLoader: PropTypes.func,
  onLoad: PropTypes.func,
  handleConfirmationRef: PropTypes.func,
  CancellationPolicy: PropTypes.string,
  hotelName: PropTypes.string,
  propertyType: PropTypes.string,
  placeHolders: PropTypes.array,
  orderSummary: PropTypes.object,
  actions: PropTypes.object,
  selectedHotelId: PropTypes.string,
  promoCode: PropTypes.string
};

const mapStateToProps = store => {
  const hotelName = getSelectedHotelName(store);
  const state = {
    // lang: store.lang,
    isMobileView: store.isMobileView,
    isRtl: isRTL(store),
    hotelName: hotelName,
    checkinDate: store.checkinDate,
    checkoutDate: store.checkoutDate,
    titles: store.titles,
    reservationId: store.reservationId,
    registrationData: store.registrationData,
    isFetchingConfirmationData: store.isFetchingConfirmationData,
    propertyType: store.propertyType,
    placeHolders: store.placeHolders,
    orderSummary: store.orderSummary,
    orderCurrency: store.orderCurrency,
    selectedHotelId: store.selectedHotelId,
    promoCode: store.promoCode
  };
  return state;
};

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    resetStore,
    getPlaceHolders,
    clearAnalyticsPlaceHolders,
    getAnalyticsPlaceHolders
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation);



// WEBPACK FOOTER //
// ./src/containers/Confirmation/Confirmation.js